import { createSlice } from "@reduxjs/toolkit";

export const movieSlice = createSlice({
  name: "movieDetails",
  initialState: {
    movieCollection: null,
  },
  reducers: {
    getMovieDetails: (state, action) => {
      state.movieCollection = action.payload;
    },
  },
});

export const { getMovieDetails } = movieSlice.actions;

export const selectMovieDetails = (state) => state.movieDetails.movieCollection;

export default movieSlice.reducer;
